// removed by extract-text-webpack-plugin
module.exports = {"list":"src-lib-components-list-__List__list--1OHpi"};


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/list/List.less
// module id = 372
// module chunks = 0